import { createContext } from 'react';

const CallsContext = createContext(null);

export default CallsContext;
